import commonApi from '@/api/api.common'
import productApi from '@/api/api.product'
export default [
  {
    type: 'select',
    placeholder: '状态',
    filed: 'status',
    default: '',
    query: commonApi.forbidden_select
  },
  {
    type: 'input',
    placeholder: '经销商名称',
    filed: 'name',
    default: ''
  },
  {
    type: 'select',
    placeholder: '经销产品',
    filed: 'productKey',
    default: '',
    query: productApi.product_select
  },
  {
    type: 'address',
    placeholder: '所在地址',
    filed: 'zone',
    default: ''
  }
]
